module.exports = __webpack_public_path__ + "img/宋志红.5fd7dd3c.jpg";